import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectMessage } from '@store/partners-order/selectors';
import { setMessage } from '@store/partners-order/slice';
import { TextArea } from '@components/text-field/TextArea';



const Message = () => {
	const { t } = useTranslation('forms');

	const message = useSelector(selectMessage);
	const dispatch = useDispatch();
	const updateMessage = (value: string | null) => dispatch(setMessage(value));

	return (
		<div className='message-section'>

			<TextArea
				label={t('inputLabels.messageLong')}
				rounded={true}
				maxLength={250}
				value={message ? message : undefined}
				onChange={(value: string) => !value && value.length === 0 ? updateMessage(null) : updateMessage(value)} />

		</div>
	);
};

export default Message;